<template>
  <div class="modal-verify-code">
    <dass-dialog
      v-if="is_modal_open"
      :title="$t('login.modals.quickAccess.titulo')"
      size="medium"
      ref="ModalVerifyCode"
      @close="HandleModal()"
    >
      <template #content>
        <div class="subtitulo" v-if="!tryByPhone && (usu_email || fone)">
          <small 
            v-if="isOperatorFlow"
            v-html="$t('login.modals.quickAccess.codeSubtituloSAC') + ': '"
          ></small>
          <small v-else
            v-html="$t('login.modals.quickAccess.codeSubtitulo') + ': '"
          ></small>
          <b> {{ usu_email || fone }}</b>
        </div>
        <form action="" @submit="formSubmit">
          <div class="items-group" v-if="!usu_email && !fone && !tryByPhone">
            <div class="checkbox-group">
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="show-email" 
                  v-model="showEmail" 
                  @change="toggleField('email')" 
                />
                <label for="show-email" class="items-checkbox">{{ $t('login.modals.quickAccess.JapossuiCodEmail') }}</label>
              </div>
            <dass-icon class="checkbox-icon" :class="brand.class_name || ''" token="icon-communication-email" size="20" />
          </div>
            <div class="input-email" v-if="showEmail">
              <dass-input-text
                type="email"
                id="input-email"
                v-model="email"
                :required="showEmail"
              />
            </div>
            <div class="checkbox-group">
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="show-phone" 
                  v-model="showPhone" 
                  @change="toggleField('phone')"
                />
                <label for="show-phone" class="items-checkbox">{{ $t('login.modals.quickAccess.JapossuiCodPhone') }}</label>
              </div>
              <dass-icon class="checkbox-icon" :class="brand.class_name || ''" token="icon-socialmedia-whatsapp" size="20" />
            </div>
            <div class="input-phone" v-if="showPhone">
            <dass-input-text
              type="phone"
              id="input-phone"
              v-model="phone"
              placeholder="+55 (11) 99999-9999"
              v-mask="['+## (##) #####-####']"
              :required="showPhone"
            />
          </div>
          </div>
          <transition name="slide-fade">
            <label v-if="tryByPhone">{{ $t('login.modals.quickAccess.receberCodPhone') }}
            <div class="input-phone tel" >
              <dass-input-text
                type="phone"
                id="input-phone"
                v-model="phone"
                placeholder="+55 (11) 99999-9999"
                v-mask="['+## (##) #####-####']"
                :required="tryByPhone"
              />
              <dass-button
                :id="`dass-button-call-code-${this.brandName}`"
                class="dass-button-call-code"
                :class="this.isSafari ? `dass-button-primary-${this.brandName}` : ''"
                variant="primary"
                @click="sendCode()"
              >
              {{ $t('login.modals.quickAccess.EnviarCodigo') }}
              </dass-button>
            </div>
          </label>
          </transition>
          <div class="form-group">
            <label for="input-code"> {{ $t('dass.codigo') }}: </label>
            <dass-input-text
              type="tel"
              id="input-code"
              v-model="code"
              :required="true"
              v-mask="{
                mask: '#######',
                tokens: {
                  '#': { pattern: /\d/ },
                },
              }"
            />
          </div>
          <div class="RetryEmail" v-if="usu_email && !isOperatorFlow">
            <dass-link :disabled="currentCountdown>0" @click="() => {
              sendCode()
              }
            "><small>{{ $t('login.modals.quickAccess.ReenviarCodEmail') }} {{ this.currentCountdown>0 ? `(${currentCountdown})` : '' }}</small>
            </dass-link>
            <dass-link v-if="sendingAttempts>0" @click="() => {
              CodeByPhone()
              }
              "><small>{{ $t('login.modals.quickAccess.receberCodPhone') }}</small>
            </dass-link>
          </div>
          <div class="footer">
            <dass-button :class="`dass-button-tertiary-${this.brandName}`" @click="cancelForm" type="button" variant="tertiary">
              {{ $t('dass.cancelar') }}
            </dass-button>
            <dass-button :class="`dass-button-primary-${this.brandName}`" type="submit" variant="primary">
              {{ $t('dass.enviar') }}
            </dass-button>
          </div>
        </form>
      </template>
    </dass-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { useIsSafari } from '@/composables/useIsSafari'
import { REGEX_EMAIL } from '../../../helpers/constants/regex'
import { validatorPhoneWithDDI } from '@/helpers/functions/telefoneValidator'

export default {
  name: 'ModalVerifyCode',
  computed: {
    ...mapGetters('modals', {
      is_modal_open: 'getModalVerifyCodeStatus',
    }),
    ...mapGetters('session', {
      usu_email: 'getUsuEmail',
      fone: 'getUsuPhone'    
    }),
    ...mapGetters('brand', { brand: 'getBrand' }),
    isOperatorFlow() {
      return !!this.$route.query.email
    }
  },
  setup() {
    const { isSafari, brandName } = useIsSafari()
  
    return {      
      isSafari,
      brandName
    }     
  },
  methods: {
    ...mapActions('modals', {
      toogleModal: 'toogleModalVerifyCode',
      toogleModalQuickAccess: 'toogleModalQuickAccess',
    }),
    ...mapActions('toasts', {
      showToast: 'showToast',
    }),
    ...mapActions('session', ['verifyCode','setUsuPhone','setUsuEmail','sendEmailCode']),

    cancelForm: function () {
      this.$refs.ModalVerifyCode.close()
      if (this.phone || this.fone) this.setUsuPhone ('')
      if (this.usu_email || this.email) this.setUsuEmail ('')
    },

    formSubmit: async function (e) {
      e.preventDefault()
      if ((!this.showEmail && !this.usu_email) && (!this.showPhone && !this.fone && !this.phone)) {
        return this.showToast({
          variant: 'warning',
          message: this.$t('login.modals.quickAccess.SelecionarEmailOuFone')
        })
      } else if ((!this.email.match(REGEX_EMAIL) && !this.usu_email & this.showEmail) || 
      (!validatorPhoneWithDDI(this.phone) && !this.fone & this.showPhone)) {
        return this.showToast({
          variant: 'warning',
          message: this.$t('login.modals.quickAccess.EmailOuFoneInvalido', {emailOrFone: this.showEmail ? this.$t('dass.email') : this.$t('dass.telefone')}),
        })
      }
      let code = this.code
      let request_body = {
        code,
      }
      if (this.usu_email || this.usu_email !== '') {
        request_body.email = this.usu_email
      }
      if (this.email || this.email !== '') {
        request_body.email = this.email
      }
      if (this.phone) {
        request_body.fone =  this.phone.replace(/\D/g, '')
      }
      if (this.fone) {
        request_body.fone =  this.fone.replace(/\D/g, '')
      }

      const response_login = await this.verifyCode(request_body)
      if (!response_login.user || response_login.user.length < 1 && !email) {
        return this.showToast({
          variant: 'warning',
          message: this.$t('login.modals.quickAccess.clienteSemEmail'),
        })
      }
      if (response_login.token !== undefined) {
        this.$refs.ModalVerifyCode.close()
        return this.$router.push('/')
      }
    },
    toggleField(selected) {
      if (selected === 'email') {
        this.showPhone = false 
        this.phone = ''
      } else if (selected === 'phone') {
        this.showEmail = false 
        this.email = ''
      }
    },
    startCountdown() {
      this.resetCountdown()
      this.countdownInterval = setInterval(() => {
        if (this.currentCountdown <= 0) {
          this.sendingAttempts++
          this.stopCountdown()
        } else {
          this.currentCountdown--
        }
      }, 1000)
    },
    stopCountdown() {
      clearInterval(this.countdownInterval)
    },
    resetCountdown() {
      this.currentCountdown = this.Countdown
    },
    HandleModal() {
      this.toogleModal(false)
      this.stopCountdown()
      this.setUsuEmail ('')
      this.tryByPhone = false
      this.sendingAttempts = 0
      this.phone = ''
      this.email = ''
      this.showPhone = false
      this.showEmail = false
    },
    sendCode: async function () {
      const phone = this.phone ? this.phone.replace(/\D/g, '') : ''
      if (!validatorPhoneWithDDI(phone) && this.tryByPhone) {
        return this.showToast({
          variant: 'warning',
          message: this.$t('login.modals.quickAccess.errophone'),
        })
      }
      const response_login = await this.sendEmailCode({email: this.usu_email ? this.usu_email : null, phone: phone ? phone: null})
      const message = response_login.message
      this.showToast({
        variant: 'success',
        message,
      })
      this.stopCountdown()
      this.startCountdown()
    },
    CodeByPhone() {
      this.tryByPhone = true
      this.setUsuEmail ('')
    }
  },
  beforeUpdate() {
    if (this.is_modal_open) this.startCountdown()
  },
  watch: {},  
  data: () => ({
    code: '',
    email: '',
    phone: '',
    showPhone: false,
    showEmail: false,
    Countdown: 25,
    currentCountdown: 25,
    countdownInterval: null,
    sendingAttempts: 0, 
    tryByPhone: false
  }),
}
</script>

<style lang="scss" scoped>
.modal-verify-code {
  .dass-dialog--contents {
    padding-top: 0;
  }
  .subtitulo {
    padding-bottom: var(--space);
  }
  label {
    font-weight: bold;
  }

  .footer {
    margin-top: var(--space__1-5x);
    display: flex;
    justify-content: space-between;
    .dass-button__primary {
      width: 250px;
    }
    .dass-button__tertiary {
      width: 250px;
    }
    .dass-button-tertiary-newbalance {
      color: var(--color-default-new-balance) !important;
      border-color: var(--color-default-new-balance) !important;  
      background-color: var(--theme-white) !important;
      transition: background-color 0.3s ease !important;
      &:hover {
        background-color: #E5788B !important;
        color: var(--theme-white) !important;
      }
    }   
    
  }
}

.theme-umbro {
  .dass-dialog--control {
    background-color: var(--theme-white) !important;
    color: var(--color-default-umbro);
  }
  .subtitulo b {
    color: var(--color-default-umbro) !important;
    text-decoration: none !important;
  }
  .dass-link {
    color: var(--color-default-umbro) !important;
  }
  .dass-button__tertiary {
    color: var(--theme-white) !important;
    text-decoration: none !important;
  }
  .dass-button__primary {
    background-color: var(--theme-white) !important;
    color: var(--theme-color) !important;
    transition: background-color 0.3s ease;
    &:hover {
      background-color: var(--color-default-umbro) !important;
      color: var(--theme-white) !important;
    }
  }
}

.RetryEmail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.input-phone, .input-email {
  display: flex;
  justify-content: center;
}
#input-email, #input-phone {
  width: 100% !important;
  padding-right: 15% !important;
}

.dass-button-call-code {
  position: relative;
  top: 14.2px;
  right: 12%;
  width: 40%;
  height: 100%; 
  padding: 10px 20px 10px 20px !important;  
}

.slide-fade-enter-active {
  margin-top: 50px;
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.dass-input-text input {
  outline: none !important;
  font-weight: normal;
}

.tel .dass-form-control.dass-input-text {
  width: 90%;
  justify-content: center;
  padding-left: 10%;
}
</style>
